import React from "react";

import "../styles/Home.css";

const Home = () => {
    return (
        <div className="home-container">
            <img
                className="home-img"
                src={require("../images/home.jpg")}
                alt="homepage background"
            />

            <div className="center-text-container">
                <div className="heading">PROFESSOR &nbsp; JONES</div>
                <div className="sub-heading">& THE RENDEZVOODOO</div>

                <p className="sub-text">swampedelic rock, soul & blues</p>
            </div>
        </div>
    );
};

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js